<template>
	<div :class="{ 'list': true, 'list--loading': loading }">
		<!-- Hide table entirely if set to only "new" insights and no results -->
		<Vuetable ref="vuetable" api-url="insights" :fields="fields" :css="css"
		          pagination-path="meta"
		          @vuetable:pagination-data="onPaginationData"
		          @vuetable:loading="onLoading"
		          @vuetable:loaded="onLoaded" @vuetable-load-error="onLoadError"
		          :http-fetch="fetch"
		          :load-on-start="loadOnStart"
		          :append-params="filters"
		          :row-class="onRowClass"
		          :min-rows="loading ? 10 : null"
		          :no-data-template="loaded && !newOnly ? 'No insights found' : ''"
		></Vuetable>

		<!-- Error while loading -->
		<div class="list__error" v-if="error">
			<span class="h2">Unable to load insights.</span>
			<button class="btn btn--link" @click.prevent="load">Retry</button>
		</div>

		<!-- Showing only "new" insights and no results -->
		<div class="list__empty" v-if="newOnly && empty">
			<span class="h2">You're all up to date!</span>
			<router-link to="/insights" class="btn btn--link">View all insights</router-link>
		</div>

		<Pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></Pagination>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Vuetable from 'vuetable-2/src/components/Vuetable';
	import ColumnInsight from './ColumnInsight';
	import ColumnSector from './ColumnSector';
	import ColumnCreated from './ColumnCreated';
	import Pagination from './Pagination';
	import FilterableList from './FilterableList';

	Vue.component('column-insight', ColumnInsight);
	Vue.component('column-sectors', ColumnSector);
	Vue.component('column-created', ColumnCreated);

	export default {
		name: 'ListInsights',
		mixins: [FilterableList],
		components: {
			Pagination,
			Vuetable,
		},
        methods: {
            resetPagination() {
                this.$refs.vuetable.changePage(1)
            },
        },
		data() {
			return {
				fields: [
					{
						name: '__component:column-insight',
						sortField: 'name',
						title: 'Insight',
					},
					{
						name: 'category',
						width: '200px',
						dataClass: 'data-label category'
					},
					{
						name: 'type',
						width: '200px',
						dataClass: 'data-label type'
					},
					{
						name: '__component:column-sectors',
						title: 'Sector',
						width: '300px',
						dataClass: 'data-sector'
					},
					{
						name: '__component:column-created',
						sortField: 'created_at',
						title: 'Created',
						titleClass: 'right',
						width: '100px',
						dataClass: 'data-label created-at'
					}
				]
			};
		},
	}
</script>
